import React from "react";
import styles from "./styles.module.scss";

const TripleDots: React.FC = () => (
  <div className={styles["wrapper"]}>
    <div className={`${styles["bounce-1"]} ${styles["dot"]}`} />
    <div className={`${styles["bounce-2"]} ${styles["dot"]}`} />
    <div className={`${styles["bounce-3"]} ${styles["dot"]}`} />
  </div>
);

export default TripleDots;
